import styled from '@emotion/styled';
import { BreakpointsEnum } from '../../helpers/breakpoints';

export const NewsletterBannerWrapper = styled.div`
    position: fixed;
    overflow: hidden;
    z-index: 1000;
    bottom: 0;
    width: 100%;
    max-height: 100%;
    box-shadow: 0 -6px 80px 0 rgba(0, 0, 0, 0.3);
    background: white;
    border-radius: 16px;
    border: 1px solid ${(props) => props.theme.border.onBg};
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    @media (min-width: ${BreakpointsEnum.sm}) {
        top: 16px;
        right: 36px;
        bottom: initial;
        width: auto;
        max-height: 730px;
        max-width: 400px;
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
    }
`;

export const NewsletterBannerContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    @media (min-width: ${BreakpointsEnum.md}) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    button.close-newsletter-banner {
        position: absolute;
        top: 0;
        right: 15px;
        z-index: 1000;
    }
`;
